import { useNavigate } from "react-router-dom";
import Navbar from "../../layouts/nav";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export default function AdminLogin(){

  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  async function login(e){
    e.preventDefault();
    if(username !== 'vishal'){
      toast.error('You are not an Admin!');
      return;
    }
    const response = await fetch('https://biouniverse-api.vercel.app/admin_login',{
      method: 'POST',
      body: JSON.stringify({username, password}),
      headers: {'Content-Type': 'application/json'},});
      
      if(response.status === 200){
        toast.success('Login Successful!');
        setTimeout(() => {
          setUsername('');
          setPassword('');
          const divs = document.querySelectorAll('.contact_input-wrap');
                    for(const div of divs){
                        setfocus(div.classList.remove('contact_focus'));
                        setEmpty(div.classList.remove('contact_not-empty'));
                    }
      },100);
        setTimeout(() => nav('/admin'), 1500);
      }else{
        toast.error('Wrong Credentials!');
      }
  }
  
  useEffect(() => {
		// List of JS files to reload
		const jsFiles = [
		  'assets/js/custom.js',
		];
	
		// script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);

    useEffect(() => {
			const videoElements = document.querySelectorAll(".lazy-video");
		
			const options = {
			  root: null,
			  rootMargin: "0px",
			  threshold: 0.1,
			};
		
			const handleIntersection = (entries, observer) => {
			  entries.forEach((entry) => {
				if (entry.isIntersecting) {
				  const video = entry.target;
				  video.src = video.dataset.src;
				  observer.unobserve(video);
				}
			  });
			};
		
			const observer = new IntersectionObserver(handleIntersection, options);
		
			videoElements.forEach((video) => {
			  observer.observe(video);
			});
		
			return () => {
			  observer.disconnect();
			};
		  }, []);



    const [transition, setTrans] = useState('none');
    const [empty, setEmpty] = useState('none');
    const [blur, setfocus] = useState('none');


    function inputFocus(e){
        setfocus(e.target.parentNode.classList.add('contact_focus'));
        setEmpty(e.target.parentNode.classList.add('contact_not-empty'));
    }

    function inputBlur(e){
            if(e.target.value == ""){
                setEmpty(e.target.parentNode.classList.remove('contact_not-empty'))
            }
            setfocus(e.target.parentNode.classList.remove('contact_focus'));
        }


        useEffect(() => {
          const handleMouseEnter = (e) => {
            const button = e.currentTarget;
            const parentOffset = button.getBoundingClientRect();
            const relX = e.pageX - parentOffset.left;
            const relY = e.pageY - parentOffset.top;
            button.querySelector("span").style.top = relY + "px";
            button.querySelector("span").style.left = relX + "px";
          };
      
          const handleMouseOut = (e) => {
            const button = e.currentTarget;
            const parentOffset = button.getBoundingClientRect();
            const relX = e.pageX - parentOffset.left;
            const relY = e.pageY - parentOffset.top;
            button.querySelector("span").style.top = relY + "px";
            button.querySelector("span").style.left = relX + "px";
          };
      
          const buttons = document.querySelectorAll(".admin_login_btn-6");
      
          buttons.forEach((button) => {
            button.addEventListener("mouseenter", handleMouseEnter);
            button.addEventListener("mouseout", handleMouseOut);
      
            return () => {
              button.removeEventListener("mouseenter", handleMouseEnter);
              button.removeEventListener("mouseout", handleMouseOut);
            };
          });
        }, []);

    return(
        <>
        <Navbar/>
        <div className="admin_sign_in_video">
						<video
                  className="lazy-video"
                  data-src="https://cdn.dribbble.com/uploads/48226/original/b8bd4e4273cceae2889d9d259b04f732.mp4?1689028949"
                  autoPlay
                  loop
                  muted
            ></video>
					</div>


       <div className="admin_login_body">
         <div className="admin_login_logo"><b>S<span>ig</span>n<span> I</span>n</b></div>
       </div>

         <div className="admin_login_login-box">
           <form className="admin_login_form" onSubmit={login}>
                <div className="contact_input-wrap admin_login_field"  style={{marginBottom: '20px'}}>
                    <input className="contact_contact-input admin_login_color" autoComplete="off" name="username" type="text" required onFocus={inputFocus} onBlur={inputBlur} style={{color: 'white;'}} value={username} onChange={e => setUsername(e.target.value)}/>
                    <label htmlFor="Username">UserName</label>
                    <i className="contact_icon fa-solid fa-address-card"></i>
                </div>

                <div className="contact_input-wrap contact_w-100 admin_login_field" style={{marginBottom: '10px'}}>
                  <input className="contact_contact-input admin_login_color" autoComplete="off" name="password" type="password" required onFocus={inputFocus} onBlur={inputBlur} value={password} onChange={e => setPassword(e.target.value)}/>
                  <label htmlFor="Password">Password</label>
                  <i className="contact_icon fa-solid fa-lock"></i>
                </div>

               <button type="submit" className="admin_login_btn-6 admin_login_button" style={{background: 'none'}}>Log In<span></span></button>
           </form>
         </div>
           <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
    />
      </>
    );
}